<template>
  <div class="extra-wrapper fs-14">
    <div class="extra-header">
      <span class="extra__element--title pa-2">
        Add ons
      </span>
      <span class="extra__element--cover pa-2">
        Cover Amount
      </span>
      <span class="extra__element--excess pa-2">
        Excess
      </span>
    </div>
    <div
      v-for="extra of mobileExtras"
      :key="extra"
      class="extra-content"
    >
      <span class="extra__element--title pa-2">
        {{ capitalizedTitle(extra) }} Cover
      </span>
      <span class="extra__element--cover pa-2">
        <span
          v-if="currentExtra(extra).cover !== null"
          class="extra__element--cover-marked"
        >
          &pound;{{ optionalExtraCover(extra).toLocaleString() }}
        </span>
        <span
          v-else
          class="fs-14"
        >
          &pound;0
        </span>
      </span>
      <span class="extra__element--excess pa-2">
        <span
          v-if="currentExtra(extra).excess !== null"
        >
          &pound;{{ currentExtra(extra).excess.toLocaleString() }}
        </span>
        <span
          v-else
          class="fs-14"
        >
          &pound;0
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { capitalize } from 'lodash';
export default {
  name: 'results-optional-extra-mobile',
  props: {
    extras: {
      type: Object,
      required: true,
    },
    mobileExtras: {
      type: Array,
      required: true,
    },
  },
  methods: {
    capitalizedTitle (title) {
      return capitalize(title);
    },
    optionalExtraCover (name) {
      const oneMillion = 1000000;
      const currentExtra = this.currentExtra(name);

      return currentExtra?.cover >= oneMillion
        ? `${currentExtra?.cover / oneMillion}m`
        : currentExtra?.cover.toLocaleString();
    },
    currentExtra (name) {
      return this.extras[name];
    },
  },
};
</script>

<style lang="scss" scoped>
.extra {
  &-header,
  &-content {
    display: flex;
    justify-content: space-between;
  }

  &__element {
    &--title,
    &--cover,
    &--excess {
      flex-shrink: 0;
    }

    &--title {
      flex-basis: 40%;
      width: 40%;
    }

    &--cover,
    &--excess {
      flex-basis: 30%;
      width: 30%;
      text-align: center;
    }

    &--cover {
      &-marked {
        color: var(--v-primary-base, $clr-primary);
      }
    }
  }
}
</style>
